export default {
    contact: 'Kapcsolat',
    references: 'Referenciák',
    language: 'Nyelv',
    termsOfUse: 'ÁSZF',
    privacy: 'Adatvédelmi szabályzat',
    references: 'Referenciák',
    login: 'Belépés',
    logout: 'Kijelentkezés',
    resetPassword: 'Jelszó visszaállítása',
    darkMode: 'Sötét Téma',
    back: 'Vissza',
    subscribe: 'Feliratkozás',
    emailAddress: 'Email cím',
    joinOurMailList: 'Iratkozz fel',
    youAreAllSetFeedback: 'Hurrá! Sikeresen feliratkoztál!',
    SendingInfoFeedback: 'Adatok küldése folyamatban...',
    mailingListFeatures: 'A legújabb fotós és digitális rajz anyagaink a postaládádban.',
    titleOfYourEntry: 'Bejegyzésed címe',
    IntroOfYourEntry: 'A feltöltésed bevezetése.',
    prologue: 'Prológus',
    live: 'Éles',
    drafts: 'Vázlat',
    draft: 'Vázlat',
    newEntry: 'Új bejegyzés',
    createNewEntry: 'Új bejegyzés létrehozása',
    createNewPost: 'Új poszt létrehozása',
    fileSizeLimit: 'Max fájlméret',
    chooseFile: 'Fájl tallózása',
    recommendedResolution: 'Ajánlott felbontás',
    deleteImage: 'Kép törlése',
    published: 'Közzétéve',
    upload: 'Feltöltés',
    story: 'Történet',
    update: 'Frissítés',
    cancel: 'Mégsem',
    iEatCookies: 'Sütiket eszek, hogy ne maradjak éhes',
    readMore: 'Tovább olvasom',
    okey: 'Rendben!',
    deleteEntryQuestion: 'Törlöd a bejegyzést?',
    thinkTwice: 'Jól gondold meg! Ezt a műveletet nem tudod visszavonni.',
    delete: 'Törlés',
    uploadTime: 'Feltöltés időpontja',
    cancel: 'Mégsem',
    save: 'Mentés',
    edit: 'Szerkesztés',
    viewEntry: 'Tovább olvasom',
    storywriter: 'Írta',
    updated: 'Frissítve',
    contactUs: 'Kapcsolatfelvétel',
    weAreHereToHelp: 'Mindig itt vagyunk, hogy segítsünk neked!',
    businessInquiries: 'Üzlettel kapcsolatban',
    businessSolutions: 'Üzelti ajánlatok, Közreműködések, Hirdetések',
    supportInquiries: 'Segítséggel kapcsolatban',
    supportSolutions: 'Hibajelentés, Funkcióigények, Platform problémák',
    supportTeam: 'Support csapat',
    street: 'utca',
    hungary: 'Magyarország',
    getThisBundle: 'Gyűjtemény letöltése',
    entryUpdateSuccess: 'Bejegyzés sikeresen frissítve.',
    entryUpdateError: 'A bejegyzést nem tudtuk frissíteni. Probléma adódott az oldalunkon :(',
    entryDeleteSuccess: 'Bejegyzés sikeresen törölve.',
    entryDeleteError: 'A bejegyzést nem tudtuk törölni. Probléma adódott az oldalunkon :(',
    entryUploadSuccess: 'Bejegyzés sikeresen feltöltve.',
    entryUploadError: 'A bejegyzést nem sikerült feltölteni. Probléma adódott az oldalunkon :(',
    coverUpdateSuccess: 'Borítókép sikeresen frissítve.',
    coverUpdateError: 'A borítókép frissítése nem sikerült. Probléma adódott az oldalunkon :(',
    profileUpdateSuccess: 'Profil sikeresen frissítve.',
    profileUpdateError: 'A profil frissítése nem sikerült. Probléma adódott az oldalunkon :(',
    keepFilesUnderLimit: 'A képek méretét 0.4 MB alatt kell tartanunk performanciai okok miatt.',
    english: 'Angol',
    hungarian: 'Magyar',
    notTranslatedToHungarian: 'Ez a bejegyzés még nem lett lefordítva magyarra.',
    publishedBy: 'Írta',
    author: 'Szerző',
    comments: 'Hozzászólások',
    share: 'Megosztás',
    newPost: 'Új bejegyzés',
    createdBy: 'Készítette',
    storyBy: 'Írta',
    lowFrequencyOfMatter: 'A tömör anyag gyakorisága nagyon alacsony errefelé.',
    changesApplyInstantly: 'A módosítások egyből élnek',
    sendPasswordResetEmail: 'Jelszóvisszaállító email küldése',
    forgotPassword: 'Elfelejtett jelszó',
    language: 'Nyelv',
    preferredLanguage: 'Preferált nyelv',
    timelinePreference: 'Idővonal működése',
    preferredEntryOrder: 'Bejegyzések preferált sorrendje',
    appearanceAndDisplay: 'Megjelenés és sémák',
    preferredAppearance: 'Preferált megjelenési beállítások',
    securityAndPassword: 'Biztonság és jelszó',
    closedBetaDisclaimer: 'A regisztráció jelenleg meghívásos alapú',
    photos: 'fotó',
    whatIsTheJournal: 'Mi az a Creatillo?',
    learnAboutTheInitiative: 'Tudj meg többet a kezdeményezésről',
    downloadReferences: 'Ingyenes fotógyűjtemények',
    recentlyPublished: 'Nemrég megosztva',
    newCover: 'Új borítókép',
    joinUsOnDiscord: 'Csatlakozz Discordon',
    discordPerks: 'Legyél közösségünk tagja',
    name: 'Név',
    editProfile: 'Profil szerkesztése',
    intro: 'Bevezetés',
    instagram: 'Instagram',
    website: 'Weboldal',
    uploadCover: 'Új borítókép',
    editCover: 'Borítókép szerkesztése',
    deleteCover: 'Borítókép törlése',
    uploadAvatar: 'Profilkép feltöltése',
    deleteAvatar: 'Profilkép törlése',
    entries: 'Bejegyzés',
    entry: 'Bejegyzés',
    posts: 'Poszt',
    post: 'Poszt',
    relatedEntry: 'Kapcsolódó Naplóbejegyzés',
    relatedPost: 'Kapcsolódó blogbejegyzés',
    recrop: 'reCrop',
    orientation: 'Arány',
    landscape: 'Fekvő',
    donateThroughPayPal: 'Támogatás PayPalen keresztül',
    likeThisTool: 'Tetszik a reCrop? Támogass!',
    reCropDescription1: 'Azért készítettem a reCropot, hogy megmentsem magamat a képek vágásának, mentésének és cloudba való feltöltésének nyomasztó terhétől. Annyi időt fektettem a fejlesztésébe, amennyi idő alatt kb. ezer képet meg tudnék vágni, menteni és feltölteni.',
    reCropDescription2: 'Dobj hozzám egy kis aprót, hogy jobban érezzem magam! De tényleg.',
    recropForInstagram: 'reCrop by Creatillo',
    recropDescription: 'Vágj fekvő képeidből állókat a reCrop segítségével!',
    cropImagesEasily: 'Képek vágása egyszerűen',
    under3mb: 'A fájl mérete 3 MB alatt kell, hogy legyen.',
    alreadyPortrait: 'A kép orientációja már álló.',
    blurBackground: 'Háttér elhomályosítása',
    notSupportedInSafari: 'Jelenleg Safariban nem támogatott',
    whyRecrop: 'Miért pont a reCrop?',
    title: 'Cím',
    subtitle: 'Alcím',
    summary: 'Összefoglalás',
    slugError: 'A slug csak kisbetűt, számot és kötőjelet tartalmazhat.',
    writeYourPostInNextStep: 'A következő lépésben tudod befejezni a bejegyzést',
    historicalTime: 'Esemény időpontja',
    january: 'január',
    february: 'február',
    march: 'március',
    april: 'április',
    may: 'május',
    june: 'június',
    july: 'július',
    august: 'augusztus',
    september: 'szeptember',
    october: 'október',
    november: 'november',
    december: 'december',
    order: 'Sorrend',
    chronology: 'Kronológia',
    newerToOlder: 'Újabbtól a régiekig',
    olderToNewer: 'Régebbitől az újakig',
    learnMoreAbout: 'Tudj meg többet arról,',
    howWeHandleData: 'hogyan kezeljük adataidat',
    and: 'és',
    whatTermsAreApplied: 'milyen feltételek vonatkoznak rád',
    whenUsingTheSite: 'a Creatillo böngészésével.',
    generalSettings: 'Általános beállítások',
    languageCurrencyAppearanceMore: 'Nyelv, Megjelenés & Egyéb',
    settings: 'Beállítások',
    year: 'Év',
    month: 'Hónap',
    day: 'Nap',
    hour: 'Óra',
    minute: 'Perc',
    copiedToClipBoard: '🌟 Sikeresen vágólapra helyezve!',
    actionError: 'Váratlan hiba történt a művelet végrehajtása közben 😔',
    confirmPageLeave: 'Az oldalon változások történtek, amiket még nem mentettél. Biztosan elhagyod az oldalt?',
    updatedLanguagePreference: 'Nyelvi beállításaidat sikeresen frissítettük 🤩',
    meetCreatillo: 'Meet Creatillo',
    menu: 'Menü',
    reply: 'Válasz',
    send: 'Küldés',
    deleteCommentDialog: 'Törlöd a hozzászólásodat?',
    deleteWithAllReplies: 'Ezzel a művelettel az összes választ is törlöd.',
    toJoinTheConversation: 'hogy csatlakozz a beszélgetéshez!',
    toStartaConversation: 'hogy beszélgetést kezdeményezz!',
    loginPrompt: 'Lépj be',
    loginWithGoogle: 'Lépj be Google fiókoddal',
    orUseEmail: 'Vagy email címmel',
    noCommentsYet: 'Még nincsenek hozzászólások.',
    passwordResetSent: 'Elküldtük az emailt jelszavad visszaállításához.',
    commentSuccessfullyDeleted: 'Hozzászólás sikeresen törölve.',
    provideEmail: 'Kérjük, add meg az email címedet!',
    nobodyHearsYou: 'Senki nem hall',
    returnToThe: 'Vissza a',
    homepage: 'Főoldalra',
    verifyYourEmail: 'Erősítsd meg az email címedet a biztonság növelése érdekében.',
    sendVerification: 'Megerősítés küldése',
    createAccount: 'Fiók létrehozása',
    createAccountPrompt: 'Hozd létre fiókodat, és formáld velünk a platform jövőjét! Ha bizonytalan vagy, nézz be előtte a Discord szerverünkre, és ismerj meg bennünket!',
    newHere: 'Új vagy itt?',
    alreadyMember: 'Van már fiókod?',
    invalidCredentials: 'Nincs ilyen fiók a rendszerünkben, vagy helytelenek a megadott adatok.',
    invalidUsername: 'Adj meg egy felhasználónevet!',
    invalidCredentialFormat: 'Ellenőrizd az email címed és jelszavad formátumát!',
    username: 'Felhasználónév',
    password: 'Jelszó',
    yourProfileUrl: 'Profilod URL-je',
    usernameIsTaken: 'A választott felhasználónév már foglalt. Válassz másikat!',
    inventoryTitle: 'Gyűjtemény',
    inventorySubtitle: 'Zsákmányaid egy helyen',
    contains: 'tartalmaz',
    images: 'képet',
    download: 'Letöltés',
    learnMore: 'Tudj meg többet',
    selectImages: 'Képek kiválasztása',
    publishEntry: 'Bejegyzés közzététele',
    entryURL: 'Bejegyzés URL-je',
    featuredEntry: 'Kiemelt bejegyzés',
    slugIsTaken: 'Ezt a slugot már egy másik bejegyzés használja. Válassz másikat!',
    slugIsTooShort: 'A slugnak legalább 5 karakter hosszúnak kell, hogy legyen.',
    imageError: 'Tölts fel legalább egy képet!',
    url: 'URL',
    fresh: 'Újdonság',
    recentlyFeatured: 'Nemrég kiemelve',
    featured: 'Kiemelve',
    entryCardPreview: 'Bejegyzés előnézete',
    advancedOptions: 'További beállítások',
    slugDescription: 'Az egyedik URL-ek segítik a keresőmotorokat abban, hogy jobban megértsék, miről szól a bejegyzésed. Ha nem adod meg, egy random azonosítót generálunk a bejegyzésed számára.',
    historicalTimeDescription: 'Az emberek böngészhetik a bejegyzéseidet az események történelmi időpontja alapján. Ha nem adod meg, akkor mindig feltöltés szerinti sorrendben fogják látni.',
    moreFrom: 'További',
    furtherWorks: 'további munkái',
    writeAComment: 'Szólj hozzá!',
    entryImageLimitReached: 'Maximum 8 képet tölthetsz fel galéria formátumú bejegyzésekhez.',
    adEngine: {
        adBy: 'Hirdetés:',
        register: {
            text: 'Ne hagyd, hogy <i>nélküled</i> induljon a küldetés',
            cta:  'Szállj fel!'
        }
    },
    cookieBar: {
        heading: 'Engeded, hogy a Creatillo sütikat használjon a böngésződben?',
        p1: 'Sütiket használnuk, hogy jobb böngészési élményt nyújtsunk, valamint jobban megismerjük a platform közönségét.',
        p2: 'Lentebb engedélyezheted, hogy az összes, vagy csak az elengedhetetlen sütiket használjuk. Tudj meg többet arról, hogy hogyan kezeljük a sütiket:',
        allowEssential: 'Elengedhetetlen sütik engedélyezése',
        allowAll: 'Összes süti engedélyezése'
    },
    follow: 'Követés',
    follower: 'Követő',
    followers: 'Követő',
    following: 'Követve',
    notifications: 'Értesítések',
    noNotifications: 'Egyelőre nincsenek értesítéseid.',
    newEntryPublished: 'közzétett egy új bejegyzést',
    newEntryComment: 'hozzászólt a bejegyzésedhez',
    newBlogComment: 'hozzászólt a posztodhoz',
    repliedOn: 'válaszolt itt',
    startedFollowingYou: 'elkezdett követni téged',
    signUp: 'Regisztráció',
    commentAs: 'Szólj hozzá, mint',
    closedRegistration: 'Iratkozz fel a várólistára, és kövesd a Discordunkat, hogy elsőként értesülj, amikor megnyílik a regisztráció.',
    entryDoesntExist: 'A bejegyzést, amit keresel, nem létezik.',
    entryDeletedOrBroken: 'Valószínűleg kitörölték, vagy a link, amit követtél, hibás volt.',
    creatorDoesntExist: 'A felhasználó, akit keresel, nem létezik.',
    creatorDeletedOrBroken: 'Valószínűleg törölte magát, vagy a link, amit követtél, hibás volt.',
    nothingHereYet: 'Egyelőre nincs itt semmi.',
    startFollowingCreators: 'Kezd el követni a kedvenc alkotóidat!',
    terms: {
        readAndAgreed: 'Elolvastam és elfogadom a',
        termsOfCreatillo: 'Creatillo Felhasználói Feltételeit',
        readAndUnderstood: 'Megértettem, hogy a szolgáltatás hogyan használja és osztja meg az adatokat, valamint hogyan kezeli a sütiket az',
        basedOn: 'alapján'
    },
    likedYourEntry: 'kedveli a bejegyzésedet',
    read: 'Elolvasni',
    comment: 'hozzászólás',
    allThe: 'Az összes',
    toComment: 'hozzászóláshoz',
    you: 'te',
    likedBy: 'Kedveli',
    likedByYou: 'Kedveled',
    other: 'személy',
    others: 'személy',
    beTheFirstToLike: 'Kedveld elsőként!',
    loadMore: 'Továbbiak betöltése',
    close: 'Bezárás',
    followedBy: 'Őket követi',
    followersOf: 'követői',
    featuredYourEntry: 'kiemelte a bejegyzésedet',
    recentlyFollowed: 'Nemrég bekövetve',
    searchCreators: 'Alkotók keresése'
}